import React, { useState } from 'react';
import './CSS/Kapcsolat.css';

const Kapcsolat = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    if (data.success) {
      setStatus('Sikeresen elküldve!');
      setForm({ name: '', email: '', message: '' });
    } else {
      setStatus('Hiba történt az üzenet elküldésekor!');
    }
  };

  return (
    <div className="kapcsolat-container">
      <h1>Kapcsolat</h1>

      <div className="kapcsolat-info">
        <p className="email">sport36@zeusbudapest.com</p>
        <p className="phone">+36 20 372 2331</p>
        <p className="address">9700 Szombathely, Kőszegi utca 19.</p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Név"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email cím"
          value={form.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Üzenet"
          rows="5"
          value={form.message}
          onChange={handleChange}
          required
        />
        <button type="submit">Küldés</button>
        {status && <p className="form-status">{status}</p>}
      </form>
    </div>
  );
};

export default Kapcsolat;
